import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {LoaderService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {ProfileService} from '@shared/services/profile.service';
import {UserProfile, UserProfileLink} from '@shared/models/user-profile.model';
import {AppConfigService} from '@shared/services/app-config.service';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {Location} from '@angular/common';
import {LinkPatientService} from '@shared/services/link-patient.service';
import {LoginService} from '@shared/services/login.service';
import {HealthCard} from '@shared/models/register.model';
import {registerDisplayModes} from '@modules/login/constants/register.constants';

@Component({
  selector: 'si-link-patient-page',
  templateUrl: './link-patient-page.component.html',
  styleUrls: ['./link-patient-page.component.scss']
})
export class LinkPatientPageComponent implements OnInit {
  @Input() isPage = true;
  @Input() displayLinkPatientPage: boolean;
  @Input() refreshUserRole: boolean;
  @Output() displayLinkPatientPageChange = new EventEmitter<boolean>();
  @Output() refreshUserRoleChange = new EventEmitter<boolean>();
  @Output() linkPatientSuccessChange = new EventEmitter<any>();
  @ViewChild('linkPatientForm') form: NgForm;
  model = new UserProfile();
  displayModeNHC: string;
  displayModeHealthCard: string;
  linkPatientErrorText: string;
  displayLinkPatientErrorDialog: boolean;
  displayLinkPatientSuccessDialog: boolean;
  registerDisplayModes = registerDisplayModes;

  constructor(
    private profileService: ProfileService,
    private loaderService: LoaderService,
    private appConfigService: AppConfigService,
    private location: Location,
    private linkPatientService: LinkPatientService,
    private loginService: LoginService
  ) {
  }

  ngOnInit(): void {
    this.getRegisterConfiguration();
    this.getUserProfile();
  }

  goBack(): void {
    if (!this.isPage) {
      this.onCloseLinkPage();
    } else {
      if (this.refreshUserRole) {
        window.location.href = '/';
      } else {
        this.location.back();
      }
    }
  }

  onCloseLinkPage(): void {
    this.displayLinkPatientPage = false;
    this.displayLinkPatientPageChange.emit(this.displayLinkPatientPage);
  }

  getRegisterConfiguration(): void {
    this.displayModeNHC = this.appConfigService.getVariableValue(configVariableValues.MANDATORY_NHC_USER);
    this.displayModeHealthCard = this.appConfigService.getVariableValue(configVariableValues.MANDATORY_HEALTHCARD_USER);
  }

  async getUserProfile(): Promise<void> {
    this.loaderService.start();
    try {
      this.model = await this.profileService.getUserProfile();
      this.model.personalData.healthCardDocument = new HealthCard();
    } finally {
      this.loaderService.stop();
    }
  }

  async onSubmit(): Promise<void> {
    if (this.form?.invalid) {
      return;
    }

    await this.updateLinkPatient();
  }

  async updateLinkPatient(): Promise<void> {
    try {
      const userProfileLink = {
        userProfile: this.model
      } as UserProfileLink;
      const patientSession = await this.loginService.updateMatchExistingPatient(userProfileLink);
      this.displayLinkPatientSuccessDialog = true;
      this.linkPatientService.setShowLinkPatientWarning(false);
      this.loginService.afterLogin(patientSession);
      this.refreshUserRole = true;
      this.refreshUserRoleChange.emit(this.refreshUserRole);
    } catch (e) {
      if (e.error?.applicationCode === 'PCS0008') {
        this.linkPatientErrorText = e.error?.message;
        this.displayLinkPatientErrorDialog = true;
      }

      throw e;
    } finally {
      this.loaderService.stop();
    }
  }

  onClickButtonCancel(): void {
    this.goBack();
  }

  onLinkPatientSuccess(displayDialog: boolean): void {
    if (displayDialog) {
      return;
    }

    this.linkPatientSuccessChange.emit();
    this.goBack();
  }

  onChangeHealthCardDocumentType(): void {
    if (!this.model.personalData.healthCardDocument.type) {
      this.model.personalData.healthCardDocument.value = null;
    }
  }
}
